import awaitState from 'await-state';
import type { Dispatch } from 'redux';
import type { Selector } from 'reselect';

import type {
  Modal,
  ModalAction,
  ModalActionType,
  ModalDefinition,
  ModalState,
  ModalStore,
} from '../types.js';

export const MODAL_SHOW_ACTION: ModalActionType = 'MODAL_SHOW';
export const MODAL_HIDE_ACTION: ModalActionType = 'MODAL_HIDE';

const createActions = (args) => {
  let modalId = 0;

  const displayed: Selector<ModalState, Modal> =
    args['modal.selectors.displayed'];

  const hide = (payload: unknown) => ({
    type: MODAL_HIDE_ACTION,
    payload,
  });

  const show =
    (definition: ModalDefinition) =>
    async (
      dispatch: Dispatch<ModalAction>,
      _: unknown,
      { store }: { store: ModalStore },
    ) => {
      const id = modalId++;

      const isOpen = (state: ModalState) => displayed(state).id === id;

      let resolveModalData: any = null;
      const modalDataPromise = new Promise(
        (resolve) => (resolveModalData = resolve),
      );

      const { onClose } = definition;
      const close = () => dispatch(hide(definition));

      const modal: Modal = {
        ...definition,
        id,
        close,
        onClose: (data) => {
          resolveModalData?.(data);

          if (onClose) {
            onClose(data);
          }
        },
      };

      dispatch({ type: MODAL_SHOW_ACTION, payload: modal });

      // may be queued initially
      await awaitState(store, isOpen);

      const result = await modalDataPromise;

      return { result };
    };

  return {
    hide,
    show,
  };
};

const actionsDefinition = {
  factory: createActions,
  dependencies: ['modal.selectors.displayed'],
};

export default actionsDefinition;
